import service from './axios';

// ==================== 素材目录 ====================
export const getMediaCategoryTree = () => service.get('/manage/media-categories/tree');
export const getMediaCategories = () => service.get('/manage/media-categories');
export const createMediaCategory = (data) => service.post('/manage/media-categories', data);
export const updateMediaCategory = (id, data) => service.put(`/manage/media-categories/${id}`, data);
export const deleteMediaCategory = (id) => service.delete(`/manage/media-categories/${id}`);

// ==================== 素材 ====================
export const getMediaList = (params) => service.get('/manage/media', { params });
export const uploadMedia = (formData) => service.post('/manage/media/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const batchUploadMedia = (formData) => service.post('/manage/media/batch-upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const updateMedia = (id, data) => service.put(`/manage/media/${id}`, data);
export const deleteMedia = (id) => service.delete(`/manage/media/${id}`);
export const batchDeleteMedia = (ids) => service.post('/manage/media/batch-delete', { ids });
